import { useState } from "react";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EvidencePanel } from "@/components/EvidencePanel";

export const UnitPhotosButton = ({ woId, unit, n, editable }) => {
  const [open, setOpen] = useState(false);
  const name = [`Unidad ${n + 1}`, unit.vehicle?.plates || unit.vehicle?.economic_number].filter(Boolean).join(" · ");
  return (
    <>
      <Button type="button" variant="outline" className="h-12 w-full border-primary/50 text-base" onClick={() => setOpen(true)} data-testid={`gps-unit-${n}-photos-button`}>
        <Camera className="mr-2 h-5 w-5" />Fotos de esta unidad
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid={`gps-unit-${n}-photos-dialog`}>
          <DialogHeader><DialogTitle>Fotos · {name}</DialogTitle></DialogHeader>
          {open && <EvidencePanel woId={woId} editable={editable} fixedUnitId={unit.id} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
